import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { SegmentedToggle } from 'src/components/design-system';
import { REPORT_VIEW } from '../../helpers/use-report-filters';
import { ReportDateRange } from './report-date-range';
import styles from './reports.module.scss';

export function ReportFilterBar({ view, onViewChange, from, until, onRangeChange, exportSlot }) {
  const lang = useSelector(getLang('EDUCATIONAL_EVENTS'));

  return (
    <div className={styles.filterBar}>
      <SegmentedToggle
        className={styles.viewToggle}
        value={view}
        onChange={onViewChange}
        options={[
          { label: lang.REPORT_BY_PERSON, value: REPORT_VIEW.PERSON },
          { label: lang.REPORT_BY_EVENT, value: REPORT_VIEW.EVENT },
        ]}
      />

      <div className={styles.filterSpacer} />

      <ReportDateRange from={from} until={until} onChange={onRangeChange} />

      {exportSlot ?? null}
    </div>
  );
}
